import React from "react";

import { EditDraftGameDialog } from "../../resources/draftgames/DraftGameModal";
import { EditGameDialog } from "../../resources/games/GameModal";
import { EditArenaSlotDialog } from "../../resources/arenaslots/ArenaSlotModal";
import { EditPracticeDialog } from "../../resources/practices/PracticeModal";

import { isDraft, isGame, isPractice, isSlot } from "./EventDetails";

const EventEditDialog = ({ editEvent, onSuccess, handleClose }) => {
  const id = editEvent?.id;

  if (!id) return null;

  return <>
    <EditDraftGameDialog
      isOpen={isDraft(editEvent)}
      id={id}
      handleClose={handleClose}
      onSuccess={onSuccess}
      skipRefresh
    />
    <EditGameDialog
      isOpen={isGame(editEvent)}
      id={id}
      handleClose={handleClose}
      onSuccess={onSuccess}
      skipRefresh
    />
    <EditArenaSlotDialog
      isOpen={isSlot(editEvent)}
      id={id}
      handleClose={handleClose}
      onSuccess={onSuccess}
      skipRefresh
    />
    <EditPracticeDialog
      isOpen={isPractice(editEvent)}
      id={id}
      handleClose={handleClose}
      onSuccess={onSuccess}
      skipRefresh
    />
  </>
}

export default EventEditDialog;
